import Nav from "../components/Nav";
import Footer from "../components/Footer";
import GetApp from "../components/GetApp";
import Contact from "../components/Contact";

const Layout = ({ children }) => {
  return (
    <div className="layout-CTA">
      <Nav />
      {children}
      <GetApp />
      <Contact />
      <Footer />
    </div>
  );
};

export default Layout;
